import React from 'react'
import { useSelector } from 'react-redux';
import { populate, useFirebaseConnect } from 'react-redux-firebase';
import useDeepCompareEffect from 'use-deep-compare-effect';
import {OtterKeg }from "./components/otter-keg/OtterKeg";
import { setKegs } from './state/KegsSlice';
import { OtterKegState, useOtterKegDispatch } from './state/OtterKegState';
import { populateKegDetails } from './utils/functionUtils';
import { BrowserRouter } from "react-router-dom";

function App() {
    const populates = [{ child: "beerId", root: "beers"}];

    useFirebaseConnect([{
        path: "kegs", 
        populates, 
        queryParams: [ 'orderByChild=isActive', 'equalTo=true' ],
        storeAs: "kegs"
    }]);
    let kegs: Object = useSelector((state: OtterKegState) => populate(state.firebase, "kegs", populates)) || {};
    let dispatch = useOtterKegDispatch();
    useDeepCompareEffect(() => {
        populateKegDetails(kegs as any).then((kegsWithDetails) => {
            dispatch(setKegs(kegsWithDetails));
        }).catch(e => {
            console.log("Error loading beer details", e)
        })
    }, [kegs])
    return (
        <BrowserRouter>
            <OtterKeg />
        </BrowserRouter>
    )
}

export default App;
